import type { SpreadPageRect } from '@/lib/backgrounds/types/spread-page-rect'
import type { SpreadPageRects } from '@/lib/backgrounds/types/spread-page-rects'
import type { BackgroundDropSlot } from '@/lib/backgrounds/types/background-drop-slot'

function pointInRect(x: number, y: number, rect: SpreadPageRect): boolean {
  return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height
}

/**
 * Matches legacy's `allowDrop` (page-editor's `odctrl.js` ~line 16746-16800): a double-page
 * background always targets the whole spread whenever the pointer is over either page; a
 * single-page background targets whichever specific page (left/right) the pointer is actually
 * over. Returns null when the pointer isn't over either page at all (e.g. bare pasteboard) —
 * there is nothing to highlight/drop onto.
 */
export function resolveBackgroundDropSlot(
  canvasX: number,
  canvasY: number,
  pageRects: SpreadPageRects,
  isDoublePageBackground: boolean
): BackgroundDropSlot | null {
  const overLeft = pageRects.left != null && pointInRect(canvasX, canvasY, pageRects.left)
  const overRight = pageRects.right != null && pointInRect(canvasX, canvasY, pageRects.right)

  if (!overLeft && !overRight) return null

  if (isDoublePageBackground) return 'double'

  return overRight ? 'right' : 'left'
}
